import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { PublicClusterInfoInterface } from "../../common/types/interfaces";

const initialState: {
  cluster: PublicClusterInfoInterface | undefined;
} = {
  cluster: undefined,
};

export const currentClusterSlice = createSlice({
  name: "current-cluster",
  initialState,
  reducers: {
    setCurrentCluster: (
      state,
      action: PayloadAction<PublicClusterInfoInterface | undefined>,
    ) => {
      state.cluster = action.payload;
    },
    clearCurrentCluster: (state) => {
      state.cluster = undefined;
    },
  },
});

export const { setCurrentCluster, clearCurrentCluster } =
  currentClusterSlice.actions;
export const selectCurrentCluster = (state: RootState) =>
  state.currentCluster.cluster;

export default currentClusterSlice.reducer;
